// define a mixin object
export default {
  methods: {
    printJson (obj) {
      // let style = 'style="background-color: rgba(64,158,255,.1); display: inline-block; padding: 0 10px; height: 32px; line-height: 30px; font-size: 12px; color: #409eff; border-radius: 4px; box-sizing: border-box; border: 1px solid rgba(64,158,255,.2); white-space: nowrap;"'
      let str = '<ul class="nested">'
      for (var p in obj) {
        if (typeof obj[p] === 'string' || typeof obj[p] === 'number' || typeof obj[p] === 'boolean') {
          str += `<li><b style="background-color: #409eff1a; display: inline-block;
            padding: 0 10px; height: 32px; line-height: 30px; font-size: 12px; color: #409eff;
            border-radius: 4px; box-sizing: border-box; border: 1px solid #409eff33;
            white-space: nowrap;">${p}</b>: <span class=numStat
            style="background-color: #42a1ff; border-radius: 4px; box-sizing: border-box;
            border: 1px solid #409eff33; color: black;">${obj[p]}</span></li>`
        } else if (Array.isArray(obj[p])) {
          str += `<li><b>${p}</b>:${this.printJson(obj[p])}</li>`
        } else if (obj[p] === null) {
          console.log('found null')
        } else {
          if (p !== '0') {
            str += `<hr><b>${p}</b>: </br>${this.printJson(obj[p])} `
          } else {
            str += this.printJson(obj[p])
          }
        }
      }
      return str + '</ul>'
    },
    backendError (err) {
      let tempMessage = ''
      if (err === 'cancel') {
        tempMessage = 'Ενέργεια ακυρώθηκε από τον χρήστη'
      } else {
        Object.keys(err.response.data.message).forEach(key => {
          tempMessage += err.response.data.message[key].reduce((acc, cur) =>
            acc.slice(0, -1) + ', ' + cur.slice(0, -1))
        })
      }

      tempMessage = tempMessage + '.'
      this.$notify.warning({
        title: 'Προειδοποίηση',
        message: tempMessage,
        offset: 300,
        duration: 5000
      })
    },
    frontEndError (msg) {
      this.$notify.error({
        title: 'Ειδοποίηση',
        message: msg,
        offset: 100,
        duration: 5000
      })
    },
    frontEndSuccessMsg (msg) {
      this.$notify.success({
        title: 'Ειδοποίηση',
        message: msg,
        offset: 100,
        duration: 5000
      })
    },
    frontEndWarningMsg (msg) {
      this.$notify.warning({
        title: 'Ειδοποίηση',
        message: msg,
        offset: 100,
        duration: 5000
      })
    },
    frontEndInfoMsg (msg) {
      this.$notify.info({
        title: 'Ειδοποίηση',
        message: msg,
        offset: 100,
        duration: 5000
      })
    },
    last (array) {
      return array[array.length - 1]
    },
    openPdfWindow (title, base64Data) {
      const pdfWindow = window.open('', title)
      pdfWindow.document.write(`
      <head>
        <title>${title}</title>
        <style>
          body { margin: 0px; }
          iframe { border-width: 0px; }
        </style>
      </head>
      <body>
        <iframe width="100%" height="100%" src="data:application/pdf;base64, ${base64Data}"></iframe>
      </body>`
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/sharedMethods.js